import React from 'react';
import styles from './index.module.scss';

const Success = ({ className }) => {
    return (
        <svg
            id='Group_9347'
            data-name='Group 9347'
            xmlns='http://www.w3.org/2000/svg'
            width='94'
            height='94'
            viewBox='0 0 94 94'
            className={className}
        >
            <circle
                id='Ellipse_115'
                data-name='Ellipse 115'
                cx='47'
                cy='47'
                r='47'
                className={styles.circle}
            />
            <path
                id='Path_3243'
                data-name='Path 3243'
                d='M100.03,161.4,80.264,142.017l6.588-6.461,13.178,12.923L129.676,119.4l6.588,6.461Z'
                transform='translate(-61.264 -92.402)'
                className={styles.icon}
            />
        </svg>
    );
};

export default Success;
